import Icon, { ICON_RIGHT } from '~/components/icon';
import { textKeysNewQDMethodCollapse } from '~/components/payment/quick-deposit-beta/components-v2/constants';
import NewQDMethodsCollapseListElement from '~/components/payment/quick-deposit-beta/components-v2/methods-element';
import {
	DepositInfo,
	InstantDepositInfoForMethods,
	QuickDepositProvider
} from '~/components/payment/quick-deposit-beta/types';
import useTranslations from '~/components/translation/use-translations';

import { MoreMethodsLink, NewQDMethodsCollapseListWrapper } from './styles';

type Props = {
	depositInfo: DepositInfo;
	onMoreMethodsClick: () => void;
	selectMethodAndExecute: (provider: InstantDepositInfoForMethods) => void;
	selectedMethod: QuickDepositProvider;
};

const NewQDMethodsCollapseList = ({
	depositInfo,
	onMoreMethodsClick,
	selectedMethod,
	selectMethodAndExecute
}: Props) => {
	const { translations } = useTranslations(textKeysNewQDMethodCollapse);
	const { NEW_QUICK_DEPOSIT_MORE_METHODS } = translations;

	return (
		<NewQDMethodsCollapseListWrapper>
			{depositInfo?.instantDepositInfoForMethods?.map(provider =>
				selectedMethod?.depositMethodId !== provider.depositMethodId ? (
					<NewQDMethodsCollapseListElement
						key={provider.depositMethodId}
						provider={provider}
						selectMethodAndExecute={selectMethodAndExecute}
					/>
				) : null
			)}
			<MoreMethodsLink onClick={onMoreMethodsClick}>
				<span className="u-text-l">{NEW_QUICK_DEPOSIT_MORE_METHODS}</span>
				<Icon height={24} width={24} type={ICON_RIGHT} />
			</MoreMethodsLink>
		</NewQDMethodsCollapseListWrapper>
	);
};

export default NewQDMethodsCollapseList;
